var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"trim",rawName:"v-trim"}],staticClass:"multiline mytextarea"},[_vm._v("\n\t"+_vm._s(_vm._f("emptyCheck")(_vm.value,_vm.emptyMessage))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }